import { render } from "./CanvasSection.vue?vue&type=template&id=c9e03c76&lang=true"
import script from "./CanvasSection.vue?vue&type=script&lang=js"
export * from "./CanvasSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__